import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideDesignAngularKit } from 'design-angular-kit';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import {
	HTTP_INTERCEPTORS,
	provideHttpClient,
	withInterceptorsFromDi,
	withFetch,
} from '@angular/common/http';
import {
	IPublicClientApplication,
	PublicClientApplication,
	InteractionType,
} from '@azure/msal-browser';
import {
	MsalInterceptor,
	MSAL_INSTANCE,
	MsalInterceptorConfiguration,
	MsalGuardConfiguration,
	MSAL_GUARD_CONFIG,
	MSAL_INTERCEPTOR_CONFIG,
	MsalService,
	MsalGuard,
	MsalBroadcastService,
} from '@azure/msal-angular';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

export function MSALInstanceFactory(): IPublicClientApplication {
	return new PublicClientApplication({
		auth: {
			clientId: environment.msalConfig.clientId,
			authority: environment.msalConfig.authority,
			knownAuthorities: environment.msalConfig.knownAuthorities,
			redirectUri: document.querySelector('base')?.href,
			postLogoutRedirectUri: document.querySelector('base')?.href,
		},
	});
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
	const protectedResourceMap = new Map([
		[environment.api_url + '/iterlex/*', environment.msalConfig.scopes],
	]);
	return {
		interactionType: InteractionType.Redirect,
		protectedResourceMap,
	};
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
	return {
		interactionType: InteractionType.Redirect,
		authRequest: {
			scopes: environment.msalConfig.scopes,
			extraQueryParameters: { authLogin: 'aad' },
		},
		loginFailedRoute: '/login-failed',
	};
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideHttpClient(withInterceptorsFromDi(), withFetch()),
		provideDesignAngularKit(),
		provideTranslateHttpLoader({ prefix: 'bootstrap-italia/i18n/' }),
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MsalInterceptor,
			multi: true,
		},
		{
			provide: MSAL_INSTANCE,
			useFactory: MSALInstanceFactory,
		},
		{
			provide: MSAL_GUARD_CONFIG,
			useFactory: MSALGuardConfigFactory,
		},
		{
			provide: MSAL_INTERCEPTOR_CONFIG,
			useFactory: MSALInterceptorConfigFactory,
		},
		MsalService,
		MsalGuard,
		MsalBroadcastService,
	],
};
